import React from 'react';
import GallectionsEmptyState from './GallectionsEmptyState';
import GallectionsEmptyStateContainer, {
  OwnProps,
} from './GallectionsEmptyState.container';

export default GallectionsEmptyStateContainer(
  GallectionsEmptyState
) as React.ComponentType<OwnProps>;
